import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import SidebarContainer from '../../components/@container/sidebar-container';
import WholesalePartsHubSidebar from '../../components/@wholesale-parts-hub/wholesale-parts-hub-sidebar';
import WholesalePartsHubPartsOrdering from '../../components/@wholesale-parts-hub/wholesale-parts-hub-parts-ordering';
import BackToTop from '../../components/back-to-top';
import { useRouter } from 'next/router';

const WholesalePartsCenterPartsOrdering: NextPage = () => {
  const router = useRouter();
  let id = router.asPath.match(/#([a-z0-9-]+)/gi)?.[0];

  if (!id) {
    id = 'independent-repair-facility';
  } else {
    id = id.replaceAll('#', '');
  }

  return (
    <Layout title="Wholesale Parts Hub Ordering" omit={true}>
      <SidebarContainer
        sidebar={<WholesalePartsHubSidebar />}
        content={<WholesalePartsHubPartsOrdering id={id} />}
      />
      <BackToTop />
    </Layout>
  );
};

export default WholesalePartsCenterPartsOrdering;
